const baseRules = [
  {
    field: 'name',
    method: 'isEmpty',
    validWhen: false,
    message: 'Real Estate Department Name is required.'
  },
  {
    field: 'stateId',
    method: 'isEmpty',
    validWhen: false,
    message: 'Real Estate Department State is required.'
  },
  {
    field: 'membershipSearchUrl',
    allowBlank: false,
    method: 'isURL',
    args: [{ protocols: ['http', 'https'], require_protocol: true, require_valid_protocol: true }],
    validWhen: true,
    message: 'Membership Search URL must be a valid URL.'
  },
  {
    field: 'siteUrl',
    allowBlank: false,
    method: 'isURL',
    args: [{ protocols: ['http', 'https'], require_protocol: true, require_valid_protocol: true }],
    validWhen: true,
    message: 'Site URL must be a valid URL.'
  },
];

export default baseRules;
